import { withHTMLComponent } from '@updater-local/custom-element-v1';
import styles from './index.css';

const html = `<img id="logo" />`;

class CompanyLogo extends withHTMLComponent(styles, html)() {
  static props = ['value', 'logoEffects'];
  static observedAttributes = ['alt'];
  static reflectedAttributes = [{ name: 'alt' }];

  constructor() {
    super();
    this._logo = this.shadowRoot.querySelector('#logo');
  }

  updated({ value: { base, path } = {}, logoEffects = {}, alt }) {
    // use the first letter from the effect to be applied to the logo
    // e.g. 'effect' => 'e', 'opacity' => o
    // in the future, if we want to use other attributes which do not map
    // cleanly to their first letter we may need to maintain a map ourselves
    let logoEffectString = Object.keys(logoEffects)
      .map(e => `${e[0]}_${logoEffects[e]}`)
      .join(',');
    if (logoEffectString) {
      logoEffectString += '/';
    }
    this._logo.src = `${base}/${logoEffectString}${path}`;
    this._logo.alt = alt;
  }
}

customElements.define('upd-moveiq-company-logo', CompanyLogo);
